import React, { useEffect, useLayoutEffect } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import LoadingSpinner from "../../../../atoms/loading-spinner";
import { IconLink } from "../../../../atoms/links";
import ModalManager from "../../../../atoms/modal-manager";
import RemoveUserModal from "../../../../modals/remove-user";
import AddUserModal from "../../../../modals/add-user";
import EditUserModal from "../../../../modals/edit-user";
import LocationDetails from "../../../../../data-containers/location-details";
import Fleets from "../../../../../data-containers/fleets";
import DynamicCell from "../../../../atoms/table/dynamic-cell";
import { parsePhoneNumberFromString } from "libphonenumber-js/index.es6.js";

function UsersContent(props) {
  const { getDetail, passiveFetchUsers, getUsersFiltered } =
    LocationDetails.useContainer();
  const { fleetPermissions } = Fleets.useContainer();
  const { location_can_edit_user, location_can_add_user } = fleetPermissions;
  const { rowData, adjustRowHeight } = props;
  const { id, expanded } = rowData;

  const detail = getDetail(id) || {};

  const { usersLoading = true } = detail;

  const users = getUsersFiltered(id);

  const listClasses = ["explorer-list user-list list"];
  if (expanded) {
    listClasses.push("expanded-list");
  }
  if (users.length > 1) {
    listClasses.push("multi-user");
  }

  useEffect(() => {
    if (detail && !detail.users) {
      passiveFetchUsers(id);
    }
  }, [detail.id]);

  useLayoutEffect(() => {
    adjustRowHeight();
  }, [users.length, expanded, usersLoading]);

  if (usersLoading) {
    return <LoadingSpinner className="inline" />;
  }

  const getRemoveUserModalProps = (u) => {
    return {
      className: "remove-user-modal",
      render: (modalProps) => (
        <RemoveUserModal u={u} location={rowData} {...modalProps} />
      ),
    };
  };

  const addUserModalProps = {
    className: "add-user-modal",
    render: (modalProps) => <AddUserModal location={rowData} {...modalProps} />,
  };

  const getEditUserModalProps = (u) => {
    return {
      className: "edit-user-modal",
      title: "Edit User Info",
      render: (modalProps) => (
        <EditUserModal u={u} location={rowData} {...modalProps} />
      ),
    };
  };

  const formatPhoneNumber = (num) => {
    try {
      return parsePhoneNumberFromString(num).formatNational();
    } catch (err) {
      return num;
    }
  };
  return (
    <React.Fragment>
      {users.length ? (
        <div className={listClasses.join(" ")}>
          {users.map((u, i) => {
            const name =
              u.user && u.user.name
                ? u.user.name
                : u.auth0User
                ? u.auth0User.name
                : "Name not found";
            return (
              <div className="explorer-item user-item list-item" key={i}>
                {expanded && users.length > 1 && location_can_edit_user && (
                  <ModalManager
                    modalProps={getRemoveUserModalProps(u)}
                    render={() => (
                      <a className="round-icon icon-link remove-user">
                        <FontAwesomeIcon icon="minus" />
                      </a>
                    )}
                  />
                )}
                <div className="user-row-label">
                  <span className="user-label">{name}</span>
                  {expanded && location_can_edit_user && (
                    <ModalManager
                      modalProps={getEditUserModalProps(u)}
                      render={() => (
                        <span className="linked-icon edit-user-link">
                          <FontAwesomeIcon icon="pencil-alt" />
                        </span>
                      )}
                    />
                  )}
                </div>
                {expanded && (
                  <div className="row-expanded-section">
                    <div className="email">{u.user.email_address}</div>
                    {u.user.phone_number && (
                      <div className="phone">
                        {formatPhoneNumber(u.user.phone_number)}
                      </div>
                    )}
                  </div>
                )}
              </div>
            );
          })}
        </div>
      ) : (
        <div className="empty">No users found</div>
      )}
      {expanded && location_can_add_user && (
        <ModalManager
          modalProps={addUserModalProps}
          render={() => (
            <IconLink icon="plus" className="add-user">
              Add User
            </IconLink>
          )}
        />
      )}
    </React.Fragment>
  );
}

function Wrapper(props) {
  return (
    <div className="location-row-users">
      <UsersContent {...props} />
    </div>
  );
}

export default DynamicCell(Wrapper);
